//////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React from 'react';
///////////////////////////////////////////////////////////   LIBS
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { ToggleSlider } from 'react-toggle-slider';
///////////////////////////////////////////////////////////   SCSS
import './header.styles.scss';
///////////////////////////////////////////////////////////   FONTAWESOME
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

///////////////////////////////////////////////////////////   INTERFACE
declare global {
  interface Window {
    darkmode: boolean | any;
  }
}
export interface PostProps {
  _mergedGenConf: any;
}
//////////////////////////////////////////////////////////////////////////////////////    CLASS SETUP
export default class Header extends React.Component<PostProps, { [key: string]: any }> {
  constructor(props: PostProps) {
    super(props);
    this.state = {
      ...props
    };
  }
  ///////////////////////////////////////////////////////////   LIFECYCLE METHODS
  componentDidMount() {
    localStorage.getItem('darkTheme') ? this.setState({ darkTheme: localStorage.getItem('darkTheme') === 'true' }) : this.setState({ darkTheme: false });
  }
  ///////////////////////////////////////////////////////////   CLASS METHODS
  switchTwoColors = () => {
    window.darkmode.toggleDarkMode();
    this.setState({ darkTheme: window.darkmode.inDarkMode }, () => {
      localStorage.setItem('darkTheme', window.darkmode.inDarkMode);
    });
  };
  ///////////////////////////////////////////////////////////   RENDER
  render() {
    let { generalConfig, darkTheme } = this.state;

    return (
      <Navbar expand='xl' className='ps-1'>
        <Navbar.Brand className='mb-1 ps-3'> {generalConfig.playerName ? generalConfig.playerName : 'MTVA'}</Navbar.Brand>
        <Navbar.Toggle aria-controls='basic-navbar-nav' />
        <Navbar.Collapse id='basic-navbar-nav'>
          <Nav className='me-auto'>
            {generalConfig.addCustomNameAfterLogo ? (
              <Nav.Link href={generalConfig.customNameHrefTo ? generalConfig.customNameHrefTo : '/#/'} target='_blank' className='nav-link-mobile'>
                {generalConfig.addCustomNameAfterLogo}
              </Nav.Link>
            ) : null}
          </Nav>
          <div id='darkModeSwitcher'></div>
          <div className='darkmodeswitcher-holder'>
            <div className='switcher-div'>
              <span className='theme-icon'>
                <FontAwesomeIcon icon="sun" />
              </span>
            </div>
            <div className='switcher-btn'>
              <ToggleSlider onToggle={this.switchTwoColors} draggable={false} active={darkTheme || localStorage.getItem('darkTheme') === 'true'} barBackgroundColor={'#ebebeb'} barBackgroundColorActive={'#ebebeb'} handleBackgroundColor={'#000'} />
            </div>
            <div className='switcher-div'>
              <span className='theme-icon'>
                <FontAwesomeIcon icon="moon" />
              </span>
            </div>
          </div>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}
